<template>
  <div v-if="question">
    <div class="form">
      <div v-if="question.type === 'radios'">
        <label class="form__label" v-if="question.label" :for="uuid">
          <span class="form__label__text">{{question.label}}</span>
        </label>
        <div class="grid align-center" role="radiogroup">
          <div class="grid__col grid__col--12 grid__col--xs-4" v-for="(option, index) in question.options" :key="index">
            <button
              class="button button--secondary has-icon button--with-icon has-check-icon"
              role="radio"
              tabindex="0"
              :aria-checked="option.checked"
              :class="[option.class]"
              :data-tealium="option['data-tealium']"
              @click="doClickRadio(option)"
              >
              <check-icon
                :checked="option.checked"
                name="svg-icon-checkmark"
                id="checkmark-nofill"
                modifier="radio small" />
              <span>{{option.label}}</span>
            </button>
          </div>
        </div>
        <!-- Divs created for subquestions with different parameters for Green Button -->
        <label class="form__label" :for="uuid" v-if="showNext">
          <span class="order-flow__item__header__headline cursor-pointer"></span>
        </label>
        <div role="radiogroup" v-if="showNext">
          <div class="grid__col grid__col--12 grid__col--xs-4" v-for="(optionExpand, groupIndex) in question.expandOptions" :key="groupIndex">
            <span class="order-flow__item__header__headline cursor-pointer">{{ optionExpand.title }}</span>
            <div class="grid align-center" v-if="optionExpand.redirectLabel">
              <div class="grid__col_gb">
                <h2>{{optionExpand.redirectLabel}}</h2>
                <p>{{optionExpand.redirectText}}</p>
                 <a class="button button--primary tealiumSubmit tealiumLink" :href="`${optionExpand.redirectLink}`"><span>{{optionExpand.button1}}</span></a>
                 <a class="button button--primary tealiumSubmit tealiumLink" :href="`${optionExpand.redirectLink1}`"><span>{{optionExpand.button2}}</span></a>
              </div>
            </div>
            <div class="grid__col grid__col--12 grid__col--xs-4" v-for="(expandOption, subGroupIndex) in optionExpand.options" :key="subGroupIndex">
              <button
                class="button button--secondary has-icon button--with-icon has-check-icon"
                :group="[groupIndex]"
                :ref="[groupIndex]"
                role="radio"
                tabindex="0"
                :aria-checked="expandOption.checked"
                :class="[expandOption.class]"
                :data-tealium="expandOption['data-tealium']"
                @click="doClickRadioCheck(expandOption, groupIndex)"
                >
                <check-icon
                  :checked="expandOption.checked"
                  name="svg-icon-checkmark"
                  id="checkmark-nofill"
                  modifier="radio small" />
                <span>{{ expandOption.label }}</span>
              </button>
            </div>
            <div class="grid">
              <div class="grid__col grid__col--12 grid__col--xs-4">
                <div v-for="(option, index) in optionExpand.showBox" :key="index"
                  class="grid__col"
                  :class="['grid__col--'+optionExpand.type]"
                >
                  <label class="form__label" :for="uuid">
                    <span class="form__label__text">{{option.label}}</span>
                  </label>
                  <input v-if="!showNextInput"
                    class="form__item_subques"
                    ref="textField"
                    v-model="option.value"
                    @keyup="doNextEnter(option)"
                    :type="optionExpand.type"
                    :id="option.id">
                  <input v-if="showNextInput"
                    class="form__item_subquesgb"
                    ref="textField"
                    v-model="option.value"
                    @keyup="doNextEnterValue(option)"
                    :id="option.id"
                    maxlength = "200">
                </div>
              </div>
              <div class="grid__col grid__col--12 grid__col--xs-8">
                <div v-for="(option, index) in optionExpand.showBoxValue" :key="index"
                  class="grid__col"
                  :class="['grid__col--'+optionExpand.type]"
                >
                  <label v-if="!showNextInput" class="form__label" :for="uuid">
                    <span class="form__label__text">{{option.label}}</span>
                  </label>
                  <input v-if="!showNextInput"
                    class="form__item_subquesgb"
                    v-model="option.value"
                    @keyup="doNextEnterValue(option)"
                    :id="option.id1"
                    maxlength = "250">
                </div>
              </div>
              <div v-if="optionExpand.button">
                <div class="grid_col" v-if="optionExpand.button[0]">
                  <button
                    class="button button--primary"
                    :data-tealium="optionExpand.button[0]['data-tealium']"
                    :class="[optionExpand.button[0].class, {'is-disabled' : !isValidExpandOptions}]"
                    :disabled="!isValidExpandOptions"
                    @click="doNext">
                    <span>{{optionExpand.button[0].label}}</span>
                  </button>
                </div>
              </div>
            </div>
            <div v-if="showSubQues" class="form__field form__field--number">
              <div v-for="(expandOption, subQuesGroupIndex) in optionExpand.subExpandQuestion" :key="subQuesGroupIndex"
                class="grid__col"
                :class="['grid__col--'+expandOption.type]"
                >
                <label class="form__label" :for="uuid">
                <span class="form__label__text">{{expandOption.title}}</span>
                </label>
                <input class="form__item_subques"
                  ref="textField"
                  v-model="expandOption.value"
                  @keyup="doNextEnterValue(expandOption)"
                  :type="expandOption.type"
                  :id="uuid">
                <div class="grid align-center">
                  <div class="grid_col">
                    <button
                      class="button button--primary"
                      :data-tealium="optionExpand.buttonCheck[0]['data-tealium']"
                      @click="doNext">
                      <span>{{optionExpand.buttonCheck[0].label}}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Divs closed for subquestions with different parameters for Green Button -->
      </div>
      <div v-else-if="question.type === 'checkboxes'" :aria-labelledby="uuid">
        <label class="form__label" v-if="question.label" :for="uuid">
          <span class="form__label__text">{{question.label}}</span>
        </label>
        <div class="grid grid__col align-center checkboxes">
          <div class="grid__col grid__col--3" v-for="(option, index) in question.options" :key="index">
            <button
              role="checkbox"
              tabindex="0"
              :aria-checked="option.checked"
              class="button button--secondary has-icon button--with-icon has-check-icon"
              ref="checkboxes"
              @click="doClickCheckbox(option)"
              >
              <check-icon
                :checked="option.checked"
                name="svg-icon-checkmark"
                id="checkmark-nofill"
                modifier="checkbox small" />
              <span>{{option.label}}</span>
            </button>
          </div>
        </div>
      </div>
      <div v-else>
        <div
          class="form__field"
          :class="['form__field--'+question.type]"
          >
          <label class="form__label" :for="uuid">
            <span class="form__label__text">{{question.label}}</span>
          </label>
          <input
            class="form__item"
            ref="textField"
            @keyup.enter="doNext"
            v-model.trim="question.value"
            :type="question.type"
            :id="uuid">
        </div>
      </div>
      <!-- Div created for subquestion showing 5 input boxes on click of yes by user -->
    </div>
    <div class="grid align-center" v-if="question.buttons">
      <div class="grid_col" v-if="question.buttons[0]">
        <button
          class="button button--primary"
          :class="[question.buttons[0].class, {'is-disabled' : !isValid}]"
          :data-tealium="question.buttons[0]['data-tealium']"
          :disabled="!isValid"
          @click="doNext"><span>{{question.buttons[0].label}}</span></button>
      </div>
    </div>
  </div>
</template>

<script>
import CheckIcon from '@/components/common/CheckIcon'
const uuidv4 = require('uuid/v4')

export default {
  name: 'QuestionsInput',
  components: {
    CheckIcon
  },
  props: {
    question: {
      type: Object,
      twoWay: true
    },
    show: {
      type: Boolean
    }
  },
  data () {
    return {
      store: this.$parent.$parent.store,
      uuid: null,
      showNext: false,
      insuranceQues: false,
      showSubQues: false,
      valueCheck: false
    }
  },
  watch: {
    'show' () {
      if ((this.question.type !== 'checkboxes') && (this.question.type !== 'radios')) {
        this.$refs.textField.focus()
      }
    }
  },

  computed: {
    isValid () {
      let _isValid = false
      if (this.question.type === 'checkboxes' || this.question.type === 'radios') {
        _isValid = this.question.options.find(option => { return option.checked })
      } else {
        _isValid = (this.question.value !== '')
      }
      return _isValid
    },

    isValidExpandOptions () {
      let _isValidExpandOptions = false
      let checkIns = 0
      if (this.question.expandOptions !== undefined) {
        for (checkIns = 0; checkIns < this.question.expandOptions.length; checkIns++) {
          if (this.question.expandOptions[checkIns].showBox !== undefined) {
            this.question.expandOptions[checkIns].showBox.forEach(element => {
              if (element.checked === true) {
                _isValidExpandOptions = true
              }
            })
          }
        }
      }
      return _isValidExpandOptions
    }
  },

  mounted () {
    this.uuid = uuidv4()
  },
  methods: {
    // Events
    doNext () {
      if (this.isValid) {
        this.$emit('next')
      }
    },

    // Green button code for passing subquestions check to App.vue
    doNextEnter (option) {
      if (option.value <= '0') {
        this.$set(option, 'checked', false)
      } else if (option.value !== undefined) {
        this.$set(option, 'checked', true)
      } else {
        this.$set(option, 'checked', false)
      }
    },

    doNextEnterValue (option) {
      if (option.value <= '0') {
        this.$set(option, 'checked', false)
      } else if (option.value !== undefined) {
        this.$set(option, 'checked', true)
      } else {
        this.$set(option, 'checked', false)
      }
    },

    // Green button code for calling functions and setting variables to open new div starts
    showConditonalQues () {
      this.showNextInput = false
      this.showNext = true
    },

    showConditonalQuesText () {
      this.showNext = true
      this.showNextInput = true
    },

    showConditonalSubQues () {
      this.showSubQues = true
    },
    // Green button code for calling functions and setting variables to open new div ends

    doClickRadio (option) {
      this.question.options.map(option => { option.checked = false })
      this.$set(option, 'checked', true)
      this.question = this.question
      setTimeout(() => {
        this.question.options.find(option => { return option.label })
        if (this.question.expandOptions !== undefined) {
          this.insuranceQues = true
          this.store.insuranceQues = this.insuranceQues
          if (option.label === this.question.value) {
            if (this.question.labelText !== undefined) {
              this.showConditonalQuesText()
            } else {
              this.showConditonalQues()
            }
          } else {
            this.showNext = false
            this.showNextInput = false
            this.showSubQues = false
            if (this.question.expandOptions[0].options !== undefined) {
              let que = 0
              for (que; que < this.question.expandOptions.length; que++) {
                this.question.expandOptions[que].options.map(option => { option.checked = false })
              }
            }
            this.doNext()
          }
        } else {
          this.showNext = false
          this.doNext()
        }
      }, 300)
    },

    // Green button code for Conditional sub questions starts
    doClickRadioCheck (optionCheck, groupIndex) {
      if (this.question.expandOptions[groupIndex].subExpandQuestion !== undefined) {
        this.question.expandOptions[groupIndex].options.map(optionCheck => { optionCheck.checked = false })
        this.$set(optionCheck, 'checked', true)
        if (optionCheck.label === this.question.value) {
          this.showConditonalSubQues()
        } else {
          this.showSubQues = false
          this.$set(optionCheck, 'checked', true)
          let counter = 0
          let group = 0
          let total = this.question.expandOptions.length
          for (group; group < total; group++) {
            let check = 0
            for (check; check < this.question.expandOptions[group].options.length; check++) {
              if (this.question.expandOptions[group].options[check].checked === true) {
                counter++
              }
            }
          }
          if (total === counter) {
            this.doNext()
          }
        }
      } else {
        this.question.expandOptions[groupIndex].options.map(optionCheck => { optionCheck.checked = false })
        this.$set(optionCheck, 'checked', true)
        let counter = 0
        let group = 0
        let total = this.question.expandOptions.length
        for (group; group < total; group++) {
          let check = 0
          for (check; check < this.question.expandOptions[group].options.length; check++) {
            if (this.question.expandOptions[group].options[check].checked === true) {
              counter++
            }
          }
        }
        if (total === counter) {
          this.doNext()
        }
      }
    },
    // Green button code for Conditional sub questions ends

    doClickCheckbox (option) {
      this.$set(option, 'checked', !option.checked)
      this.question = this.question
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @media only screen and (max-width: 768px) {
    /* make checkboxes take the full width */
    .grid.checkboxes .grid__col {
      flex: 100%;
    }
  }
    .form__item_subques {
      padding-left:1% !important;
      position: relative;
      z-index: 1;
      height: 3rem;
      line-height: 1rem;
      padding: 0.938rem 0.938rem 0.938rem;
      font-size: 16px;
      margin-right: 60px;
      border: 1px solid #bdbdbd;
    }

    .grid_gb_col {
      width: 100%;
    }

    .form__item_subquesgb {
      padding-left:1% !important;
      position: relative;
      z-index: 1;
      height: 3rem;
      line-height: 1rem;
      padding: 0.938rem 0.938rem 0.938rem;
      font-size: 16px;
      margin-right: 60px;
      border: 1px solid #bdbdbd;
    }

  @media only screen and (max-width: 768px) {
    .order_flow_gb {
      display: inline-block;
      font-size: 1.563rem;
      cursor: pointer;
    }
  }

    .order_flow_gb {
      display: inline-block;
      font-size: 1.563rem;
      cursor: pointer;
      margin-left: 3%;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/questions/QuestionsInput.vue